import React from "react";
// Assets
import ClientLogo01 from "../../assets/img/clients/logo01.png"
import ClientLogo02 from "../../assets/img/clients/logo02.png";
import ClientLogo03 from "../../assets/img/clients/logo03.png";
import ClientLogo04 from "../../assets/img/clients/logo04.png";
import ClientLogo05 from "../../assets/img/clients/logo05.png";

export default function ClientSlider() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 items-center">
      <div className="w-full h-auto cursor-pointer">
        <img src={ClientLogo01} alt="client logo" className="w-full h-auto p-6" />
      </div>
      <div className="w-full h-auto cursor-pointer">
        <img src={ClientLogo02} alt="client logo" className="w-full h-auto p-6" />
      </div>
      <div className="w-full h-auto cursor-pointer">
        <img src={ClientLogo04} alt="client logo" className="w-full h-auto p-6" />
      </div>
      <div className="w-full h-auto cursor-pointer">
        <img src={ClientLogo03} alt="client logo" className="w-full h-auto p-6" />
      </div>
      <div className="w-full h-auto cursor-pointer">
        <img src={ClientLogo05} alt="client logo" className="w-full h-auto p-6" />
      </div>
    </div>
  );
}
